import type { PaymentStatus } from '@/components/billing/billing-types';

export function paymentStatusBadgeVariant(
  status: PaymentStatus
): 'default' | 'secondary' | 'destructive' | 'outline' {
  switch (status) {
    case 'paid':
      return 'default';
    case 'pending':
      return 'secondary';
    case 'past_due':
      return 'destructive';
    case 'void':
      return 'outline';
    case 'other':
      return 'outline';
  }
}
